export const comments_4504528 = {"data":{"data":[],"links":{}}}